<div class="layout-outer-container">
    <div class="layout-container">
        <app-header></app-header>
        <div class="layout-content">
            @if (loading) {
            <div class="page-container">
                <p class="text">Validating...</p>
                <div class="center-container">
                    <img class="loading" src="/assets/images/icons/loading.svg" alt="">
                </div>
            </div>
            } @else if (!hasKey) {
            <div class="page-container">
                <p class="text">Invalid API Key</p>

                <div class="center-container">
                    <img class="error" src="/assets/images/icons/error.svg" alt="">
                </div>
                <div class="disclaimer">You don't have a valid Key.<br> Please contact keynexis for assistance!</div>
            </div>
            } @else {
            <router-outlet></router-outlet>
            }
        </div>
        <div class="layout-footer">
            <div>
                OperatorsApp 2.0.0
            </div>
            @if(location && (appType !== appTypeEnum.stocking || !dynSystem)){
            <div>
                <mat-icon>location_on</mat-icon> <b>{{location}}</b>
            </div>
            }
            @if(appType === appTypeEnum.stocking && dynSystem){
            <div>
                <mat-icon class="dark">location_on</mat-icon> <b>{{dynSystem}}</b>
            </div>
            }
            @if(apiKey && validUntil){
            <div>
                <mat-icon>vpn_key</mat-icon>{{apiKey}}
            </div>
            <div>
                <mat-icon>event_busy</mat-icon>{{validUntil | date:'dd.MM.YYYY'}}
            </div>
            }
        </div>
    </div>
</div>